var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{ref:"playiframe",staticClass:"w-100 vh-95",attrs:{"src":_vm.iframeSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }